import React, { useState } from 'react';
import './Integration.css';

const Integration = () => {
  const [activeTab, setActiveTab] = useState('connected');
  const [integrations, setIntegrations] = useState([
    {
      id: 1,
      name: 'LinkedIn Recruiter',
      description: 'Sync candidate profiles and job postings',
      status: 'connected',
      icon: '🔗',
      lastSync: '2 hours ago'
    },
    {
      id: 2,
      name: 'Workday HRIS',
      description: 'Employee data and payroll integration',
      status: 'connected',
      icon: '📊',
      lastSync: '1 day ago'
    },
    {
      id: 3,
      name: 'Slack',
      description: 'Team notifications and alerts',
      status: 'pending',
      icon: '💬',
      lastSync: 'Not connected'
    },
    {
      id: 4,
      name: 'Google Calendar',
      description: 'Schedule interviews and meetings',
      status: 'available',
      icon: '📅',
      lastSync: 'Available'
    },
    {
      id: 5,
      name: 'Zoom',
      description: 'Video interviews and meetings',
      status: 'available',
      icon: '🎥',
      lastSync: 'Available'
    },
    {
      id: 6,
      name: 'Greenhouse',
      description: 'ATS and candidate tracking',
      status: 'available',
      icon: '🌱',
      lastSync: 'Available'
    }
  ]);

  const filteredIntegrations = integrations.filter(integration => {
    if (activeTab === 'connected') return integration.status === 'connected';
    if (activeTab === 'pending') return integration.status === 'pending';
    return integration.status === 'available';
  });

  const handleConnect = (id) => {
    setIntegrations(integrations.map(integration =>
      integration.id === id 
        ? { ...integration, status: 'pending', lastSync: 'Connecting...' }
        : integration
    ));
  };

  const handleDisconnect = (id) => {
    setIntegrations(integrations.map(integration =>
      integration.id === id 
        ? { ...integration, status: 'available', lastSync: 'Available' }
        : integration
    ));
  };

  return (
    <div className="hrcopilot-integration">
      <div className="integration-header">
        <h1 className="integration-title">HR Copilot Integrations</h1>
        <p className="integration-subtitle">
          Connect your favorite tools to streamline your HR workflow
        </p>
      </div>

      <div className="integration-tabs">
        <button
          className={`tab-button ${activeTab === 'connected' ? 'active' : ''}`}
          onClick={() => setActiveTab('connected')}
        >
          Connected ({integrations.filter(i => i.status === 'connected').length})
        </button>
        <button
          className={`tab-button ${activeTab === 'pending' ? 'active' : ''}`}
          onClick={() => setActiveTab('pending')}
        >
          Pending ({integrations.filter(i => i.status === 'pending').length})
        </button>
        <button
          className={`tab-button ${activeTab === 'available' ? 'active' : ''}`}
          onClick={() => setActiveTab('available')}
        >
          Available ({integrations.filter(i => i.status === 'available').length})
        </button>
      </div>

      <div className="integration-grid">
        {filteredIntegrations.map(integration => (
          <div key={integration.id} className="integration-card">
            <div className="integration-card-header">
              <div className="integration-icon">{integration.icon}</div>
              <div className="integration-badge integration-badge--connected">
                {integration.status.charAt(0).toUpperCase() + integration.status.slice(1)}
              </div>
            </div>
            
            <div className="integration-card-body">
              <h3 className="integration-name">{integration.name}</h3>
              <p className="integration-description">{integration.description}</p>
              <div className="integration-meta">
                <span className="integration-sync">Last sync: {integration.lastSync}</span>
              </div>
            </div>

            <div className="integration-card-footer">
              {integration.status === 'connected' && (
                <button 
                  className="integration-btn integration-btn--disconnect"
                  onClick={() => handleDisconnect(integration.id)}
                >
                  Disconnect
                </button>
              )}
              {integration.status === 'pending' && (
                <button className="integration-btn integration-btn--pending" disabled>
                  Connecting...
                </button>
              )}
              {integration.status === 'available' && (
                <button 
                  className="integration-btn integration-btn--connect"
                  onClick={() => handleConnect(integration.id)}
                >
                  Connect
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {filteredIntegrations.length === 0 && (
        <div className="integration-empty">
          <div className="empty-icon">🔌</div>
          <h3>No integrations found</h3>
          <p>There are no {activeTab} integrations at the moment.</p>
        </div>
      )}
    </div>
  );
};

export default Integration;